import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import BarrieraErrori from './components/BarrieraErrori';
import './index.css';

// La barriera sta fuori da tutto: qualunque pagina si rompa, al posto della
// schermata bianca compare un messaggio leggibile e l'errore arriva a noi.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BarrieraErrori>
      <App />
    </BarrieraErrori>
  </React.StrictMode>
);
